<template>
    <modal
        :title="modalTitle"
        :message="modalMessage"
        :options="modalOptions"
        :show="showModal('timeout')"
        type="timeout"
    />
</template>

<script>

export default {
    name: 'TimeoutModal',
    computed: {
        gameId() {
            return parseInt(this.$route.params.id, 10);
        },
        modalTitle() {
            return 'Time limit exceeded';
        },
        modalMessage() {
            return 'Your opponent is taking too long to make a decision. ' +
                'Would you like to claim victory for this game?';
        },
        modalOptions() {
            return [
                {
                    label: 'Yes',
                    callback: this.onConfirm,
                    type: 'primary',
                },
                {
                    label: 'No',
                    callback: this.onCancel,
                    type: 'secondary',
                },
            ];
        },
    },
    methods: {
        showModal(type) {
            return this.$store.state.modalState.modals[type].show;
        },
        onConfirm() {
            this.$store.dispatch('sendTimeoutRequest', this.gameId);
        },
        onCancel() {
            this.$store.dispatch('closeModal', 'timeout');
        },
    },
};
</script>

<style scoped lang="scss">
    @use "@/styles/styles.scss" as *;

</style>
